import * as React from 'react';
import SectionHeader from '@able/react/dist/SectionHeader';
import Grid from '@able/react/dist/Grid';
import Column from '@able/react/dist/Column';
import Spacing from '@able/react/dist/Spacing';
import { generateElementId } from '@applications/order-tracker/utils';
import {
  OrderDetailsSections,
  OrderSummarySurfaceCornerRadius,
} from '../../../../config/order-tracker-new-common/constants';
import OrderSummarySections from './order-summary-sections';
import '../../style.less';
import { ILoadOrderDetailsNewRequest } from '@telstra-connect/order-tracker/state/order-details';
import { IOrderTrackerAppState } from '@telstra-connect/order-tracker/state';
import { useSelector } from 'react-redux';

const OrderSummary = () => {
  const orderDetailsNew: ILoadOrderDetailsNewRequest = useSelector(
    (state: IOrderTrackerAppState) => state.orderTracker.orderDetailsNew
  );
  const { data } = orderDetailsNew;
  return (
    <section
      id={generateElementId(OrderDetailsSections.OrderSummary)}
      data-testid={generateElementId(OrderDetailsSections.OrderSummary)}
    >
      <Spacing top="spacing7x" bottom="spacing7x">
        <Grid>
          <Column cols={12}>
            <SectionHeader
              title={OrderDetailsSections.OrderSummary}
              headingElement="h2"
              variantLevel="Level1"
              subtitle=""
              actionLabel=""
            />
          </Column>
        </Grid>
        <Grid className="order-summary-sm-md-lg">
          <Column cols={12}>
            <OrderSummarySections
              surfaceCornerRadius={OrderSummarySurfaceCornerRadius.Soft}
              orderSummary={data.orderSummary}
            />
          </Column>
        </Grid>
        <OrderSummarySections
          className="order-summary-xs"
          surfaceCornerRadius={OrderSummarySurfaceCornerRadius.None}
          orderSummary={data.orderSummary}
        />
      </Spacing>
    </section>
  );
};

export default OrderSummary;
